import { render, staticRenderFns } from "./VehicleInfo.vue?vue&type=template&id=bbb6a426&scoped=true&"
import script from "./VehicleInfo.vue?vue&type=script&lang=js&"
export * from "./VehicleInfo.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInfo.vue?vue&type=style&index=0&id=bbb6a426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb6a426",
  null
  
)

export default component.exports